module.exports = __webpack_public_path__ + "img/11.571651a7.jpeg";